module.exports = __webpack_public_path__ + "img/site_type_img_14.b6fe41e9.png";